import {
  FaMapMarkerAlt,
  FaRegClock,
  FaStar,
  FaPlane,
  FaHome,
  FaBed,
  FaCoffee,
  FaHiking,
  FaUtensils,
  FaSnowflake,
  FaFlag
} from "react-icons/fa";
import { IoMdArrowDropright, IoMdCheckmarkCircle } from "react-icons/io";
import { AppContext } from "../../App";
import { useContext } from "react";

import imageHero from "../../assets/kili.jpg";
import imageDay1 from "../../assets/kili2.jpg";
import imageDay2 from "../../assets/mtkili.jpg";
import imageDay3 from "../../assets/kili.jpg";
import imageDay4 from "../../assets/kili2.jpg";
import imageDay5 from "../../assets/mtkili.jpg";
import imageDay6 from "../../assets/kili.jpg";
import imageDay7 from "../../assets/kilimanjaro.jpg";

const hero = {
  kicker: "7 DAYS Marangu Route",
  title: "Coca-Cola Route",
  subtitle: "The only route with hut accommodations instead of tents.",
  backgroundImage: imageHero,
  meta: ["7 Days", "Hut accommodations", "Coca-Cola route"],
};

const overview = `Marangu route is also called "Coca-cola route", the only route up to where you sleep in the huts than tents. An advance booking of hut accommodation is required to avoid last minute inconvenience. The minimum number of days to complete this route is 5days, an optional day of acclimatization at Horombo Hut is highly recommended to increase your chances of success to the summit.`;

const highlights = [
  {
    icon: FaHome,
    title: "Hut Accommodations",
    description: "Unique route with comfortable huts instead of tents every night.",
    color: "#dc2626"
  },
  {
    icon: FaBed,
    title: "Acclimatization Day",
    description: "Dedicated rest day at Horombo Hut to improve summit success.",
    color: "#f59e0b"
  },
  {
    icon: FaHiking,
    title: "Classic Route",
    description: "The original and most popular Kilimanjaro route with gentle gradients.",
    color: "#10b981"
  },
  {
    icon: FaRegClock,
    title: "Best Seasons",
    description: "January–March and June–October for optimal weather and visibility.",
    color: "#3b82f6"
  },
];

const details = [
  {
    icon: FaMapMarkerAlt,
    title: "Route",
    description: "Marangu Gate > Mandara Hut > Horombo Hut > Kibo Hut > Uhuru Peak > Horombo > Marangu Gate.",
  },
  {
    icon: FaRegClock,
    title: "Duration",
    description: "7 days including acclimatization day at Horombo Hut.",
  },
  {
    icon: FaBed,
    title: "Accommodation",
    description: "Mountain huts with bunk beds, dining halls, and basic amenities at each camp.",
  },
  {
    icon: FaCoffee,
    title: "Comfort Focus",
    description: "Warmer sleeping arrangements and communal spaces for a more accessible climb.",
  },
];

const itinerary = [
  {
    dayLabel: "Day 1",
    dayNum: "01",
    title: "Arrival in Moshi",
    image: imageDay1,
    body: "Upon arrival at Kilimanjaro Airport, you will be met and warmly greeted by Kwetu Africa Adventures representative who will take you to your place of stay in Moshi for Dinner and an Overnight.",
    activities: "Airport transfer, hotel stay",
    tags: ["Arrival", "Moshi", "Pre-Trek Rest"]
  },
  {
    dayLabel: "Day 2",
    dayNum: "02",
    title: "Marangu Gate to Mandara Hut (6,100ft – 8,860ft)",
    image: imageDay2,
    body: "In the morning, after breakfast and a thorough briefing, we drive to Marangu Gate for Park formalities before we trek up. The climb starts from Marangu Gate. We walk through the lush lower slopes of Mount Kilimanjaro. Slowly gaining altitude while enjoying the diverse flora and fauna of the rain forest – At the upper edge of the forest line, you have the opportunity to see Blue or Sykes Monkeys. The trail then widens to expose beautiful hillsides until we reach Mandara Hut at 8,860ft above sea level.",
    activities: "Hiking Time: 5hours, Distance: 8Kms, Habitat: Montane Rainforest",
    tags: ["Rainforest", "Wildlife", "Mandara Hut"]
  },
  {
    dayLabel: "Day 3",
    dayNum: "03",
    title: "Mandara Hut to Horombo Hut (8,860ft – 12,155ft)",
    image: imageDay3,
    body: "From Mandara continue up through the upper rainforest zone and reach the Moorland Zone at 9845 ft. In this zone, plants grow to outrageous heights like the Giant Lobelia and Giant Groundsel (Senecio Kilimanjaro) that can reach up to 16 ft to make you enjoy the views of the semi-alpine zone's plants and ravines. On a clear day, Kibo will glimmer in a distance, with the sightings of the majestic glacier in the morning sun. Arrive at Horombo Hut on a small plateau and get some rest for the next day's adventure.",
    activities: "Hiking Time: 6hours, Distance: 11.6Kms, Habitat: Heath",
    tags: ["Giant Lobelia", "Kibo Views", "Horombo Hut"]
  },
  {
    dayLabel: "Day 4",
    dayNum: "04",
    title: "Horombo Hut – A Day of Acclimatization (12,155ft)",
    image: imageDay4,
    body: "This extra day at Horombo is meant to give you additional acclimatization. A few hours hike to Mawenzi Hut at 13,120ft (3hours up and 1.5hours down) via Zebra Rock is strongly recommended. After lunch, you will have an afternoon at leisure to regain your strength for another day.",
    activities: "Acclimatization hike, rest day",
    tags: ["Acclimatization", "Zebra Rock", "Rest Day"]
  },
  {
    dayLabel: "Day 5",
    dayNum: "05",
    title: "Horombo Hut to Kibo Hut (12,155ft – 15,520ft)",
    image: imageDay5,
    body: "After breakfast ascends into Alpine desert habitat and pass the \"Last Watering Point\" at 13,550ft where you will have to refill your water bottles with all the water you will need for the next two nights, until you come back to Horombo Hut or you opt to buy mineral water at Kibo Hut). Kibo area is an Alpine barren desert with no water streams nearby, where you will spend the night – the night is always short, sleeping early is recommended.",
    activities: "Hiking Time: 6hours, Distance: 9.6Kms, Habitat: Alpine Desert",
    tags: ["Alpine Desert", "Last Water Point", "Kibo Hut"]
  },
  {
    dayLabel: "Day 6",
    dayNum: "06",
    title: "Summit Day: Kibo Hut to Uhuru Peak to Horombo Hut",
    image: imageDay6,
    body: "Today is the \"Big Day\" – the final stage to the summit and you will begin to ascend at around midnight – this will be a long and strenuous day. The climb is slow but surely goes upward. At sunrise you will be at Gilman's Point (18,640ft), the rim of Kilimanjaro where the sun starts to warm up the land and make you forget the cold of the night. After 1 – 2hours you will have reached at Uhuru Peak at 19,340ft, the highest point in Africa. Afterwards you will have 3hours descend back to Kibo Hut, take a break and collect all your gears you left behind on your ascent and walk down to Horombo Hut (3hours) for overnight. The return to Horombo seems surprisingly fast compared to ascent.",
    activities: "Hiking Time: 7 – 8hours Ascent, Hiking Time: 6 – 8hours Descent, Distance: 20.5Kms",
    tags: ["Midnight Start", "Uhuru Peak", "Summit Achievement"]
  },
  {
    dayLabel: "Day 7",
    dayNum: "07",
    title: "Horombo Hut to Marangu Gate (15,520ft – 5,240ft)",
    image: imageDay7,
    body: "A gentle trek takes you down through the montane forest to Marangu Gate, where you will complete Park formalities and receive Certificates, which you can hang up with pride! You are then met by our vehicles and return to the hotel in Arusha, where you can treat yourself to a welcome shower (and a cold beer or two!).",
    activities: "Hiking Time: 6hours, Distance: 19.7Kms, Habitat: Montane Forest",
    tags: ["Descent", "Certificate", "Celebration"]
  },
];

export default function MaranguRoute() {

  const appContext = useContext(AppContext);
  
  // Marangu "Coca-Cola Route" theme: Warm reds, comfort-focused, accessible
  const theme = {
    primary: "#dc2626",      // Red-600 (Coca-Cola inspired, warmth)
    primaryLight: "#ef4444", // Red-500
    accent: "#b91c1c",       // Red-700 (depth)
    bg: "#fff7ed",           // Warm orange-50 (comfort/accessible)
    cardBg: "#ffffff",
    text: "#1e293b",
    textMuted: "#64748b"
  };

  return (
    <div style={{ 
      maxWidth: "1400px", 
      margin: "0 auto", 
      fontFamily: "system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif",
      color: theme.text,
      background: theme.bg
    }}>
      
      {/* ================= HERO SECTION ================= */}
      <section
        style={{
          height: "75vh",
          minHeight: "500px",
          backgroundImage: `linear-gradient(135deg, rgba(23, 15, 12, 0.88), rgba(185, 28, 28, 0.78)), url(${hero.backgroundImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundAttachment: "fixed",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "white",
          textAlign: "center",
          padding: "0 1.5rem",
          position: "relative"
        }}
      >
        <div style={{ maxWidth: "800px", animation: "fadeInUp 0.8s ease-out" }}>
          <span 
            className="badge rounded-pill px-4 py-2 mb-4"
            style={{ 
              background: "rgba(239,68,68,0.25)", 
              border: "1px solid rgba(239,68,68,0.5)",
              color: "#fca5a5",
              fontSize: "0.9rem",
              fontWeight: "600",
              letterSpacing: "0.5px",
              backdropFilter: "blur(4px)"
            }}
          >
            {hero.kicker}
          </span>
          
          <h1 
            style={{ 
              fontSize: "clamp(2.5rem, 6vw, 4rem)", 
              marginBottom: "1rem", 
              lineHeight: 1.1,
              fontWeight: "700",
              textShadow: "0 2px 15px rgba(0,0,0,0.5)"
            }}
          >
            {hero.title}
          </h1>
          
          <p 
            style={{ 
              fontSize: "clamp(1.1rem, 2.5vw, 1.35rem)", 
              marginBottom: "2.5rem",
              opacity: 0.95,
              lineHeight: 1.6
            }}
          >
            {hero.subtitle}
          </p>
          
          <div style={{ display: "flex", gap: "0.75rem", justifyContent: "center", flexWrap: "wrap" }}>
            {hero.meta.map((m, i) => (
              <span 
                key={i} 
                style={{ 
                  background: "rgba(255,255,255,0.18)", 
                  padding: "0.5rem 1.25rem", 
                  borderRadius: "50px",
                  fontSize: "0.9rem",
                  fontWeight: "500",
                  border: "1px solid rgba(255,255,255,0.25)",
                  backdropFilter: "blur(4px)"
                }}
              >
                {m}
              </span>
            ))}
          </div>
        </div>
      </section>

      <div style={{ padding: "4rem 1.5rem" }}>
        
        {/* ================= OVERVIEW ================= */}
        <section style={{ marginBottom: "5rem", textAlign: "center", maxWidth: "800px", margin: "0 auto 5rem" }}>
          <h2 
            style={{ 
              fontSize: "clamp(1.75rem, 4vw, 2.25rem)", 
              marginBottom: "1.5rem", 
              color: theme.text,
              fontWeight: "700"
            }}
          >
            The Comfortable Path to Uhuru Peak
          </h2>
          <p 
            style={{ 
              fontSize: "1.1rem", 
              lineHeight: 1.8, 
              color: theme.textMuted,
              marginBottom: "2rem"
            }}
          >
            {overview}
          </p>
          
          {/* Quick Stats */}
          <div className="row g-3 justify-content-center" style={{ display: "flex", gap: "1rem", flexWrap: "wrap" }}>
            {details.map((d, i) => {
              const DIcon = d.icon;
              return (
                <div 
                  key={i}
                  className="col-6 col-md-3"
                  style={{
                    background: theme.cardBg,
                    padding: "1rem 1.5rem",
                    borderRadius: "12px",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
                    display: "flex",
                    alignItems: "center",
                    gap: "0.75rem",
                    minWidth: "200px",
                    border: "1px solid rgba(0,0,0,0.04)"
                  }}
                >
                  <DIcon size={22} style={{ color: theme.primary, flexShrink: 0 }} />
                  <div style={{ textAlign: "left" }}>
                    <div style={{ fontSize: "0.8rem", fontWeight: "600", color: theme.text }}>{d.title}</div>
                    <div style={{ fontSize: "0.85rem", color: theme.textMuted }}>{d.description}</div>
                  </div>
                </div>
              );
            })}
          </div>
        </section>

        {/* ================= HIGHLIGHTS GRID ================= */}
        <section style={{ marginBottom: "5rem" }}>
          <div className="text-center mb-4">
            <h2 
              style={{ 
                fontSize: "clamp(1.75rem, 4vw, 2.25rem)", 
                marginBottom: "0.5rem", 
                color: theme.text,
                fontWeight: "700"
              }}
            >
              Why Choose the Marangu Route?
            </h2>
            <p style={{ color: theme.textMuted }}>The most accessible path to Africa's highest peak</p>
          </div>
          
          <div style={{ 
            display: "grid", 
            gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", 
            gap: "1.5rem" 
          }}>
            {highlights.map((h, i) => {
              const HIcon = h.icon;
              return (
                <article 
                  key={i} 
                  style={{ 
                    background: theme.cardBg,
                    padding: "1.75rem",
                    borderRadius: "16px",
                    boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
                    transition: "transform 0.3s ease, box-shadow 0.3s ease",
                    cursor: "default",
                    border: "1px solid rgba(0,0,0,0.04)",
                    position: "relative",
                    overflow: "hidden"
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-4px)";
                    e.currentTarget.style.boxShadow = "0 12px 28px rgba(0,0,0,0.12)";
                    e.currentTarget.style.borderColor = h.color + "66";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow = "0 4px 14px rgba(0,0,0,0.08)";
                    e.currentTarget.style.borderColor = "rgba(0,0,0,0.04)";
                  }}
                >
                  {/* Subtle gradient accent */}
                  <div 
                    className="position-absolute top-0 end-0 opacity-10"
                    style={{
                      width: "100px",
                      height: "100px",
                      background: `radial-gradient(circle at top right, ${h.color}33, transparent 70%)`,
                      borderRadius: "0 0 0 100%"
                    }}
                  />
                  
                  <div 
                    className="d-inline-flex align-items-center justify-content-center rounded-2 mb-3 position-relative"
                    style={{
                      width: "52px",
                      height: "52px",
                      background: `linear-gradient(135deg, ${h.color}20, ${h.color}10)`,
                      color: h.color,
                      fontSize: "1.4rem",
                      border: `1px solid ${h.color}40`
                    }}
                  >
                    <HIcon />
                  </div>
                  <h3 style={{ fontSize: "1.25rem", marginBottom: "0.75rem", fontWeight: "600", color: theme.text, position: "relative" }}>
                    {h.title}
                  </h3>
                  <p style={{ color: theme.textMuted, lineHeight: 1.6, fontSize: "0.95rem", margin: 0, position: "relative" }}>
                    {h.description}
                  </p>
                </article>
              );
            })}
          </div>
        </section>

        {/* ================= ITINERARY TIMELINE ================= */}
        <section>
          <div className="text-center mb-5">
            <h2 
              style={{ 
                fontSize: "clamp(1.75rem, 4vw, 2.25rem)", 
                marginBottom: "0.5rem", 
                color: theme.text,
                fontWeight: "700"
              }}
            >
              Your 7-Day Hut-Based Journey
            </h2>
            <p style={{ color: theme.textMuted }}>Comfortable accommodations at every camp on your ascent</p>
          </div>

          <div style={{ position: "relative" }}>
            {/* Timeline connector line (desktop) */}
            <div 
              className="d-none d-lg-block"
              style={{
                position: "absolute",
                left: "50%",
                top: "0",
                bottom: "0",
                width: "2px",
                background: `linear-gradient(to bottom, ${theme.primary}33, ${theme.accent}33, transparent)`,
                transform: "translateX(-50%)"
              }}
            />

            {itinerary.map((day, i) => (
              <article 
                key={i} 
                className={`row g-4 align-items-center mb-4 ${i % 2 === 0 ? 'flex-lg-row' : 'flex-lg-row-reverse'}`}
                style={{
                  background: theme.cardBg,
                  borderRadius: "20px",
                  overflow: "hidden",
                  boxShadow: "0 6px 20px rgba(0,0,0,0.08)",
                  border: "1px solid rgba(0,0,0,0.04)",
                  transition: "transform 0.3s ease, box-shadow 0.3s ease",
                  position: "relative",
                  zIndex: 1
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-3px)";
                  e.currentTarget.style.boxShadow = "0 14px 35px rgba(0,0,0,0.12)";
                  e.currentTarget.style.borderColor = i === itinerary.length - 1 ? theme.accent + "66" : theme.primary + "66";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "0 6px 20px rgba(0,0,0,0.08)";
                  e.currentTarget.style.borderColor = "rgba(0,0,0,0.04)";
                }}
              >
                {/* Day Number Badge - Red theme with hut icon for comfort */}
                <div 
                  className="position-absolute top-0 start-0 m-3 rounded-pill px-3 py-1 d-flex align-items-center gap-1"
                  style={{
                    background: `linear-gradient(135deg, ${theme.primary}, ${theme.primaryLight})`,
                    color: "white",
                    fontWeight: "700",
                    fontSize: "0.8rem",
                    zIndex: 2,
                    boxShadow: "0 4px 12px rgba(220, 38, 38, 0.4)"
                  }}
                >
                  <FaHome size={12} /> Day {day.dayNum}
                </div>

                {/* Image Column */}
                <div className="col-lg-5" style={{ position: "relative", minHeight: "280px" }}>
                  <div
                    style={{
                      height: "100%",
                      minHeight: "280px",
                      backgroundImage: `url(${day.image})`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      transition: "transform 0.5s ease"
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.transform = "scale(1.03)"}
                    onMouseLeave={(e) => e.currentTarget.style.transform = "scale(1)"}
                  />
                  {/* Gradient overlay for text readability */}
                  <div 
                    style={{
                      position: "absolute",
                      inset: 0,
                      background: "linear-gradient(to top, rgba(23,15,12,0.75), transparent 60%)"
                    }}
                  />
                </div>

                {/* Content Column */}
                <div className="col-lg-7 p-4 p-lg-5">
                  <h3 
                    style={{ 
                      fontSize: "1.4rem", 
                      marginBottom: "1rem", 
                      fontWeight: "700",
                      color: theme.text,
                      paddingRight: "60px",
                      lineHeight: 1.3
                    }}
                  >
                    {day.title}
                  </h3>
                  
                  <p style={{ lineHeight: 1.7, color: theme.textMuted, marginBottom: "1.25rem", fontSize: "0.95rem" }}>
                    {day.body}
                  </p>
                  
                  {/* Tags */}
                  <div style={{ display: "flex", gap: "0.5rem", flexWrap: "wrap", marginBottom: "1.25rem" }}>
                    {day.tags.map((tag, idx) => (
                      <span 
                        key={idx}
                        style={{
                          background: `${theme.primary}10`,
                          color: theme.primary,
                          padding: "0.35rem 0.85rem",
                          borderRadius: "50px",
                          fontSize: "0.8rem",
                          fontWeight: "500",
                          border: `1px solid ${theme.primary}25`
                        }}
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                  
                  {/* Activities/Elevation Info - Hut-themed badge */}
                  <div 
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: "0.5rem",
                      padding: "0.6rem 1.2rem",
                      background: `linear-gradient(135deg, ${theme.primary}15, ${theme.primary}08)`,
                      borderRadius: "10px",
                      fontSize: "0.9rem",
                      color: theme.primary,
                      fontWeight: "500",
                      border: `1px solid ${theme.primary}30`
                    }}
                  >
                    <FaBed size={14} />
                    {day.activities}
                  </div>
                </div>
              </article>
            ))}
          </div>
        </section>

        {/* ================= HUT COMFORT HIGHLIGHT ================= */}
        <section 
          style={{ 
            background: `linear-gradient(135deg, ${theme.primary}08, ${theme.accent}08)`,
            borderRadius: "20px",
            padding: "2.5rem 2rem",
            marginTop: "3rem",
            border: `1px solid ${theme.primary}20`
          }}
        >
          <div className="text-center mb-4">
            <FaHome size={36} style={{ color: theme.primary, marginBottom: "1rem" }} />
            <h3 
              style={{ 
                fontSize: "clamp(1.4rem, 3vw, 1.75rem)", 
                fontWeight: "700", 
                marginBottom: "0.75rem",
                color: theme.text
              }}
            >
              Hut Comfort Features
            </h3>
            <p style={{ color: theme.textMuted, fontSize: "0.95rem" }}>What makes the Marangu Route uniquely comfortable</p>
          </div>
          <div className="row g-3 justify-content-center" style={{ display: "flex", gap: "1rem", flexWrap: "wrap" }}>
            {[
              "Solid Bunk Beds with Mattresses at Every Camp",
              "Communal Dining Huts with Hot Meals Served",
              "Protected Sleeping Areas – No Tent Setup Required",
              "Warmer Night Experience – Ideal for Cooler Months",
              "Simpler Logistics – Less Gear to Carry Personally",
              "Great for First-Time Climbers Seeking Comfort"
            ].map((item, idx) => (
              <div 
                key={idx}
                className="col-12 col-md-6 col-lg-4"
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: "0.75rem"
                }}
              >
                <IoMdCheckmarkCircle size={20} style={{ color: theme.primary, flexShrink: 0, marginTop: "2px" }} />
                <span style={{ fontSize: "0.95rem", color: theme.text, lineHeight: 1.5 }}>{item}</span>
              </div>
            ))}
          </div>
        </section>

        {/* ================= CTA SECTION ================= */}
        <section 
          className="text-center mt-6 pt-5"
          style={{ 
            borderTop: `1px solid rgba(0,0,0,0.06)`,
            background: `linear-gradient(135deg, ${theme.primary}08, ${theme.accent}08)`,
            borderRadius: "20px",
            padding: "3rem 2rem",
            marginTop: "4rem"
          }}
        >
          <FaCoffee size={42} style={{ color: theme.primary, marginBottom: "1rem" }} />
          <h3 
            style={{ 
              fontSize: "clamp(1.5rem, 4vw, 2rem)", 
              fontWeight: "700", 
              marginBottom: "1rem",
              color: theme.text
            }}
          >
            Ready for Your Comfortable Summit Adventure?
          </h3>
          <p style={{ color: theme.textMuted, maxWidth: "600px", margin: "0 auto 2rem", lineHeight: 1.6 }}>
            Book your Marangu Route expedition with hut accommodations included. Perfect for first-time climbers or those who prefer a more comfortable ascent. Advance hut booking required.
          </p>
          <button 
            className="btn btn-lg px-5 py-3 rounded-pill"
            style={{ 
              background: `linear-gradient(135deg, ${theme.primary}, ${theme.primaryLight})`,
              border: "none",
              fontWeight: "600",
              color: "white",
              boxShadow: `0 6px 20px ${theme.primary}40`,
              display: "inline-flex",
              alignItems: "center",
              gap: "0.5rem",
              transition: "transform 0.2s ease, box-shadow 0.2s ease"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-2px)";
              e.currentTarget.style.boxShadow = `0 8px 25px ${theme.primary}50`;
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow = `0 6px 20px ${theme.primary}40`;
            }}
            onClick={() => appContext.navTo({item:'plan-trip'})}
          >
            Reserve Your Hut Spot <IoMdArrowDropright size={20} />
          </button>
          <p style={{ fontSize: "0.85rem", color: theme.textMuted, marginTop: "1.5rem", margin: 0 }}>
            <FaRegClock size={14} className="me-1" /> Free pre-trek consultation • Hut booking assistance included
          </p>
        </section>

      </div>

      {/* ================= CSS ANIMATIONS ================= */}
      <style>{`
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @media (prefers-reduced-motion: reduce) {
          * { transition: none !important; animation: none !important; }
        }
        @media (max-width: 991px) {
          [style*="left: 50%"] { display: none !important; }
        }
      `}</style>
    </div>
  );
}